export default __webpack_public_path__ + "c6abb5ab4b3125ac1d92773c36481372.svg";